import React, { useEffect, useState } from 'react'
import tw, { styled } from 'twin.macro'
import InfoIcon from '@components/Icons/InfoIcon'
import Button, { ButtonVariant, ButtonSize } from './Button'

const Container = styled.div`
  ${tw`bg-primary-light`}
  ${tw`border border-solid border-primary-grey`}
  ${tw`rounded-4 rounded-tl-none`}
  ${tw`text-primary-normal`}
  ${tw`relative z-10`}

  padding: 16px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-gap: 8px;
`

const Title = styled.div`
  font-size: 16px;
  line-height: 20px;
`

const Message = styled.div`
  ${tw`text-gray-800`}
  font-size: 12px;
  line-height: 16px;

  &:nth-child(2) {
    margin-top: 4px;
  }
`

const StyledButton = styled(Button)`
  align-self: center;
  margin: -4px 0;
`

type Props = {
  title?: string
  message: string
  okText?: string
  onOk?: React.MouseEventHandler
  visible?: boolean
}

function Callout(props: Props) {
  const { title, message, okText = 'OK', onOk, visible: visibleProp, ...otherProps } = props
  const [visible, setVisible] = useState(visibleProp ?? true)

  useEffect(() => {
    if (visibleProp === undefined) return

    setVisible(visibleProp)
  }, [visibleProp])

  const onClick = (e) => {
    if (onOk) return onOk(e)

    setVisible(false)
  }

  if (!visible) return null

  return (
    <Container {...otherProps}>
      <InfoIcon style={{ margin: title ? '-2px 0' : '-4px 0' }} />
      <div tw="flex-grow">
        {title && <Title>{title}</Title>}
        <Message>{message}</Message>
      </div>
      <StyledButton variant={ButtonVariant.primary} size={ButtonSize.small} onClick={onClick}>
        {okText}
      </StyledButton>
    </Container>
  )
}

export default Callout
